module.exports = __webpack_public_path__ + "static/media/trash.34b6fd11.svg";